import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './SignUp.css';
import Button from './Button';

function SignUp() {
  const navigate = useNavigate();
  
  // State for form inputs
  const [displayName, setDisplayName] = useState('');
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [code, setCode] = useState('');
  
  // State for messages
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.body.style.background = 'linear-gradient(180deg, #930203 0%, #930203 50%, #ffffff 50%)';
    const rawUser = localStorage.getItem('user');
    if (rawUser) {
      navigate('/dashboard', { replace: true });
    }
    return () => { document.body.style.background = ''; };
  }, [navigate]);

const handleSubmit = async (e) => {
  e.preventDefault();
  setError('');
  setLoading(true);

  try {
    const apiUrl = process.env.REACT_APP_API_URL;
    const response = await fetch(`${apiUrl}/signup.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        displayName,
        username,
        email,
        password,
        code
      })
    });

    const data = await response.json();

if (response.ok) {
  // Store user data in localStorage (same as login)
  localStorage.setItem('user', JSON.stringify(data.user));
  if (data.rememberToken) {
    localStorage.setItem('rememberToken', data.rememberToken);
  }
  navigate('/profile-picture');
}
    else {
      // Show the actual error message from PHP
      setError(data.error || 'Signup failed');
    }
  } catch (err) {
    // Only show "Network error" if there's actually a network problem
    setError('Could not connect to server. Please check your connection.');
    console.error('Signup error:', err);
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="signup-page" style={{
      background: 'linear-gradient(180deg, #930203 0%, #690202 100%)',
      minHeight: '100dvh',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      position: 'fixed',
    }}>
      <div className="sec-break" style={{ height: '100px' }}></div>

<form onSubmit={handleSubmit} className="signup-modal d-flex flex-column justify-content-between">
  
  <div className="signup-top d-flex flex-column gap-2">
    <Link to="/" className="back-btn w-25 mb-4">←</Link>
    <p className="signup-label mt-4">ACCOUNT VERIFICATION</p>
    <h2 className="signup-heading fw-semibold">Sign Up</h2>

    {/* Form inputs */}
    <Button 
      as="input" 
      type="text" 
      placeholder="Display Name" 
      value={displayName}
      onChange={(e) => setDisplayName(e.target.value)}
    />
    <Button 
      as="input" 
      type="email" 
      placeholder="Email" 
      value={email}
      onChange={(e) => setEmail(e.target.value)}
    />
    <Button 
      as="input" 
      type="text" 
      placeholder="Twitter username" 
      value={username}
      onChange={(e) => setUsername(e.target.value.replace(/^@+/, ''))}
    />
    <Button 
      as="input" 
      type="password" 
      placeholder="Password" 
      value={password}
      onChange={(e) => setPassword(e.target.value)}
    />
    <Button 
      as="input" 
      type="text" 
      placeholder="Code" 
      value={code}
      onChange={(e) => setCode(e.target.value)}
    />

    {/* Error message */}
    {error && (
      <div style={{ 
        color: '#930203', 
        fontSize: '14px', 
        backgroundColor: '#ffe6e6',
        padding: '10px',
        borderRadius: '5px',
        border: '1px solid #930203',
        marginTop: '10px',
        marginBottom: '10px',
      }}>
        {error}
      </div>
    )}
  </div>

  <div className="signup-bot mb-4">
    <Button variant="cta" type="submit" disabled={loading}>
      {loading ? 'Creating...' : 'Next'}
    </Button>
  </div>

</form>
    </div>
  );
}

export default SignUp;


